export default __webpack_public_path__ + "static/media/31fe8f5871873a1ca50897be8494ff3e.png";